/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

function TermsOfUse() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Terms of Use</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='tou__section'>
				<div className='col-12 col-md-10 offset-md-1 offset-0'>
					<p>
						Hi there! Welcome to The Etho. We’re really excited
						that you’re here, and we want you, as a The Etho
						user, to stay informed on what we do, what we don't
						do, and what we expect of everyone on The Etho. For
						your convenience, we have detailed our Terms of Use
						(“Terms”) below –– we ask that you read through
						them, understand them (or ask us to help you
						understand them!), adhere to them, and that you
						expect the same of us. We are always happy to answer
						any questions you may have about these Terms and
						what they mean for you as a member of the The Etho
						community.
					</p>
					<ol>
						<li>
							<h4 className=''>
								Accepting The Etho's Terms of Use
							</h4>
							<p>
								The following document and the other related
								documents assembled/linked to below
								constitute The Etho’s (The Etho Inc.’s, “The
								Etho”) operational policies and guidelines,
								and will serve as The Etho’s rules.
								Collectively, we will call all of these
								provisions The Etho's Terms of Use (“these
								Terms” or “the Terms”). These Terms are a
								legally binding contract between you and The
								Etho, Inc., which is the legal name of The
								Etho’s parent company. We will refer to
								ourselves (including The Etho's website, all
								of The Etho's associated applications and
								services/service entities) as “The Etho”.
								This contract sets out your responsibilities
								and rights as a The Etho user, whether you
								are a buyer, seller, or a potential buyer or
								seller.
							</p>
							<ol>
								<li>
									<p>
										By using any of The Etho’s
										“services” (i.e., all components of
										our company listed above), as well
										as simply navigating or perusing The
										Etho's website, you automatically
										agree to these Terms.
									</p>
								</li>
								<li>
									<p>
										If you do not agree with any of
										these Terms, you may not use The
										Etho's services in any form or
										fashion.
									</p>
								</li>
								<li>
									<p>
										The Etho’s policies apply to
										everyone, regardless of whether
										you’re using The Etho as a buyer, a
										seller, or otherwise. Use of any of
										The Etho's services detailed herein
										constitutes agreement to these
										Terms, including: The Etho's
										Anti-Discrimination Policy; User
										Privacy &amp; Online Communications
										Policy; Privacy Policy; Intellectual
										Property Policy; Community
										Guidelines; Prohibited Things
										Policy; Sanctions Guidelines; Fees
										and Payment Policy; Trademarks
										Policy; Dispute Resolution Process
										and Returns/Exchanges Policy; Online
										Communications Policy; and our
										Seller Expectations. All of these
										policies are a part of The Etho's
										Terms, so be sure to read them all
										carefully.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Your Account with The Etho
							</h4>
							<p>
								In order to use The Etho, and any of The
								Etho's services, you must create a user
								account. Our account rules are detailed
								below and are an important part of your
								participation in The Etho’s activities
								whether as buyer or seller –– so we suggest
								you read them carefully and become familiar
								with them.
							</p>
							<ol>
								<li>
									<p>
										You must be at least 18 years of
										age, or older, to use The Etho’s
										services in any capacity. If you are
										not 18 years of age, and are 13
										years old, you may only use The
										Etho’s services under the active
										supervision of a parent or legal
										guardian who is required to manage
										your The Etho account for you.
										Children under 13 year of age are
										not allowed to use The Etho or The
										Etho's services in any capacity.
									</p>
								</li>
								<li>
									<p>
										By creating a The Etho account, you
										acknowledge and agree to be solely
										responsible for any activity on your
										account. If you share a The Etho
										account with other individuals, then
										the person whose billing information
										is on the account is ultimately
										responsible for any and all
										activities on that The Etho account.
									</p>
								</li>
								<li>
									<p>
										You are charged with protecting your
										The Etho account password. Because
										you are solely responsible for any
										and all activity on your account, we
										suggest that you maintain the
										security of your account password
										and other related information, and
										that you refrain from sharing or
										communicating such information to
										others unnecessarily.
									</p>
								</li>
								<li>
									<p>
										You must provide The Etho with
										accurate information about yourself;
										and it is therefore strictly
										prohibited to use false information
										of any kind, or to impersonate
										another person or entity, through
										your account name(s), activities,
										communications, or the like.
									</p>
								</li>
								<li>
									<p>
										If you choose to register with The
										Etho as a business entity, by doing
										so you are guaranteeing that you
										posses the authority to agree and
										consent to these Terms on behalf of
										that business. All The Etho accounts
										are also non-transferable.
									</p>
								</li>
								<li>
									<p>
										All users of The Etho’s services,
										even if you decide not to list your
										full name as the name associated
										with your The Etho account, are
										still prohibited from using any
										language that is offensive,
										libelous, threatening,
										inappropriate, or that infringes
										upon someone else’s intellectual
										property rights (or otherwise
										violates these Terms).
									</p>
								</li>
								<li>
									<p>
										These Terms of Use do not constitute
										the creation of any partnership,
										joint venture, employment, franchise
										relationship or agency of any kind
										between The Etho and you, or between
										The Etho and your company.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								User Privacy on The Etho
							</h4>
							<p>
								Our Privacy Policy details how your
								information is used when you use The Etho's
								services, to view the Privacy Policy, please
								&nbsp;
								<a href='/privacy_policy'>click here.</a>
							</p>
						</li>
						<li>
							<h4 className=''>
								Indemnification information
							</h4>
							<ol>
								<li>
									<p>
										If the relationship between The Etho
										and The Etho's sellers is found to
										be one of “joint data control” of
										customers’ personal information, and
										The Etho is fined or sued because of
										something that you did qua joint
										data controller of customers’
										personal information, you hereby
										agree to indemnify The Etho for any
										expenses we occur in connection with
										your controlling and processing of
										customers’ information.
									</p>
								</li>
								<li>
									<p>
										We hope this never happens, but if
										The Etho is sued in connection to
										something that you, as a buyer or
										seller, did, you hereby agree to
										defend and indemnify us. This means
										that you will defend us and hold The
										Etho harmless from any legal claim
										or demand, including any of The
										Etho's employees and any and all
										reasonable attorney’s fees that may
										arise from your actions, your use or
										misuse of The Etho's services, your
										breach of these Terms, or your
										account’s infringement on another
										individual’s rights.
									</p>
								</li>
								<li>
									<p>
										The Etho reserves the right to
										determine and execute The Etho's own
										legal defense in any manner we see
										fit, even in light of your
										consenting to indemnification of The
										Etho outlined here, in which case
										you agree to cooperate with us
										accordingly.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Use of The Etho's services
							</h4>
							<p>
								We hereby grant you a limited,
								non-exclusive, non-transferable, and
								revocable license to use The Etho’s
								services; one that is subject to all of
								these Terms, in addition to the following
								restrictions:
							</p>
							<ol>
								<li>
									<p>
										The names “The Etho” and "The Etho,"
										and all other The Etho trademarks,
										phrases, logos, and designs employed
										by us in connection to our services,
										are licensed trademarks, service
										marks, or trade dress of The Etho in
										the United States, and in other
										countries. If you’d like to use any
										of our trademarks, please adhere
										completely to The Etho's Trademarks
										Policy.
									</p>
								</li>
								<li>
									<p>
										By using any of The Etho’s services,
										you acknowledge and agree that you
										will not violate any laws in
										connection with the use of those
										services. This includes, but is not
										limited to, any local, state,
										federal, and international laws
										applicable to you. It is your
										responsibility to obtain any
										licenses and/or permits required for
										lawful operation of your shop, and
										you must operate in compliance with
										The Etho’s Sanctions Policy, and are
										prohibited from engaging in theft,
										fraud, anti-competitive conduct,
										threatening conduct, or any other
										unlawful acts or crimes against The
										Etho, another The Etho user, or any
										and all third parties.
									</p>
								</li>
								<li>
									<p>
										By using The Etho’s services you are
										agreeing to never interfere, or
										attempt to interfere, with those
										services by distributing a virus or
										other harmful computer code, or, in
										any other way.
									</p>
								</li>
								<li>
									<p>
										By using The Etho’s services you are
										agreeing not to “crawl,” “scrape,”
										or “spider” any page of The Etho’s
										services or to reverse engineer or
										attempt to obtain the source code of
										our services.
									</p>
								</li>
								<li>
									<p>
										By using any The Etho service, you
										acknowledge and agree that you are
										responsible for paying all fees that
										you owe to The Etho. You are also
										solely responsible for collecting
										and/or paying any applicable taxes
										or duties for any sales or purchases
										you make through The Etho’s
										services.
									</p>
								</li>
								<li>
									<p>
										The Etho will provide you or your
										representatives with limited legal
										information in writing. By using The
										Etho's services, you are agreeing to
										our Online Communications Policy,
										which describes how we communicate
										that specific information to you. It
										states that The Etho can send you
										information electronically (e.g., by
										email or online message) instead of
										mailing you hard copies, and that
										The Etho's electronic or digitally
										displayed agreement in all cases is
										the same as The Etho's signature on
										paper.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Content Associated with Your The Etho
								Account
							</h4>
							<p>
								Any and all content that you post while
								using The Etho’s services will be considered
								your content, and not The Etho’s. We neither
								endorse, nor make any claim of ownership to
								your content. “Your content” includes
								anything posted by you or your
								representatives while using The Etho’s
								services. This includes, but is not limited
								to: shop or account names, pictures of any
								kind, profile photos, item descriptions,
								customer reviews, comments by you or
								customers, videos, etc. The following
								guidelines serve as the rules for meeting
								The Etho's content standards:
							</p>
							<ol>
								<li>
									<p>
										By displaying or posting content
										through The Etho’s services, you
										automatically grant The Etho license
										to use that content. The Etho does
										not claim any ownership of your
										account’s content, but does retain
										your permission to use said content
										for any purposes deemed by The Etho
										to help The Etho expand, operate
										effectively, and/or develop. This
										license is primarily in place to
										help size, display, advertise,
										translate, market, and share your
										shop, your shop’s products and
										images/content, and to do so in a
										way that helps The Etho expand and
										optimize web presence and increase
										sales.
									</p>
									<p>
										This means that by posting any
										content, you automatically grant The
										Etho an irrevocable, sub-licensable,
										worldwide, royalty-free,
										non-exclusive, perpetual license to
										utilize, replicate, keep, modify,
										redistribute, or to create
										derivative works, of your content in
										order to maintain The Etho’s
										services, and for the purposes of
										promoting The Etho or your The Etho
										shop, in any format, and through any
										method, including throughout any The
										Etho services or third-party
										websites or advertisements. We claim
										this right in order to better market
										our platform and increase the
										revenue our sellers bring in through
										The Etho.
									</p>
								</li>
								<li>
									<p>
										Respect for intellectual property
										rights is a central priority for The
										Etho, and we are committed to
										adhering to and following
										appropriate legal procedures to
										remove infringing content from The
										Etho's services. If you own content,
										whether written or visual, that has
										been displayed in any of The Etho’s
										services without your permission,
										and you want it removed, please
										follow the procedures detailed in
										The Etho's Intellectual Property
										Policy. We will be happy to
										accommodate you.
									</p>
								</li>
								<li>
									<p>
										If content associated with your
										account infringes upon another
										person’s intellectual property
										rights, The Etho will remove it upon
										notification, and will contact you
										about it.
									</p>
								</li>
								<li>
									<p>
										You hereby acknowledge that you are
										solely responsible for any and all
										of your content on The Etho. This
										means that you claim to posses all
										necessary rights to any content
										associated with your The Etho
										account, and that you are not
										infringing upon or violating any
										other party’s rights by displaying
										or using it.
									</p>
								</li>
								<li>
									<p>
										You hereby agree that you will not
										post any written or visual content
										that may be considered abusive,
										threatening, defamatory, obscene,
										vulgar, or otherwise offensive or in
										violation of The Etho's Prohibited
										Things Policy, Community Guidelines,
										or any part of these Terms. You also
										agree not to post any content that
										is false, misleading, or that uses
										any The Etho service in a manner
										that is fraudulent and/or deceptive.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Limitation of Liability
							</h4>
							<p>
								By using The Etho, you understand and agree
								that The Etho does not manufacture, store,
								or inspect any of the items sold through our
								services. No products sold through The Etho
								are owned by The Etho; we merely determine
								whether or not products can be sold in our
								virtual marketplace (The Etho) based on
								their adherence to our Fair Trade standards
								of production. By using The Etho, you
								acknowledge that The Etho screens sellers to
								determine whether or not they qualify as
								“Fair Trade” in line with our own ethical
								standards, which, while based on widely
								accepted international principles of Fair
								Trade (outlined by the World Fair Trade
								Organization), do not necessarily rely
								solely upon, or invoke any formal
								relationship with or approval of, any
								international Fair Trade labeling
								organization.
							</p>
							<ol>
								<li>
									<p>
										You hereby release The Etho from all
										liability relating to your
										interactions with other users of our
										services. We urge all The Etho users
										to exercise caution in all
										interactions with other The Etho
										users.
									</p>
								</li>
								<li>
									<p>
										You agree that The Etho is not
										responsible for the copyright
										compliance, legality, accuracy, or
										non-offensiveness of any content
										posted by The Etho users, and
										accessible to you through our
										services. You hereby release The
										Etho from all liability related to
										that content.
									</p>
								</li>
								<li>
									<p>
										You hereby release The Etho from any
										legal claims related to items sold
										through The Etho's services,
										including for defective items, the
										misrepresentation of products by
										sellers, or products that may cause
										physical injury (product liability
										claims).
									</p>
								</li>
								<li>
									<p>
										Because the items sold in The Etho's
										marketplace are listed, made, and
										sold directly by independent sellers
										or groups, The Etho cannot and does
										not make any warranties about their
										quality or safety. Any legal claim
										you may have related to an item you
										purchase on The Etho must be
										directed against the seller of that
										product(s), and not against The
										Etho.
									</p>
								</li>
								<li>
									<p>
										You hereby acknowledge that The Etho
										does not make any warranties with
										respect to The Etho's gift card
										balance and is not responsible for
										any unauthorized access to, or
										alteration, theft, or destruction of
										a gift card or gift card code that
										results from any action by you or by
										a third-party. You also agree that
										The Etho may prohibit the use of our
										gift card if a The Etho gift card or
										gift card code has been reported
										stolen or lost, or if we believe
										that a gift card balance is being
										used fraudulently, or in any
										otherwise unauthorized manner. By
										participating in any special
										promotion or offer, you
										automatically agree to the rules of
										that special promotion or offer.
									</p>
								</li>
								<li>
									<p>
										The Etho services may display links
										to separate, product-related
										third-party websites or other
										services that The Etho does not
										control or own in any way (e.g.,
										links to Twitter, Facebook,
										Pinterest, etc.). You may utilize a
										third-party’s service or product in
										relation to one or more aspects of
										The Etho's services (e.g., a mobile
										device with which to use The Etho's
										mobile app). During any and all
										instances of accessing third-party
										services, you hereby agree to do so
										at your own risk, regardless of
										these third-parties’ own terms of
										use. You agree that The Etho is not
										a party to those agreements, and
										that they are solely between you and
										the third-party in all cases.
									</p>
								</li>
								<li>
									<p>
										In no event shall The Etho’s
										aggregate liability for any damages
										exceed the larger of one hundred
										($100) US Dollars, or the amount you
										paid The Etho in the past twelve
										months. (Some jurisdictions may not
										allow these limitations on
										incidental or consequential damages,
										so the stated limitations may not
										apply to you).
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Disputes with The Etho and with Other Users
							</h4>
							<p>
								If you enter into a dispute with another The
								Etho user, or a third-party, we urge you (or
								your representatives) and the disputing
								party to resolve the disagreement(s)
								amicably. Buyers and sellers who are unable
								to resolve a dispute related to a
								transaction carried out on The Etho's
								websites or mobile app, may participate in
								The Etho's dispute resolution process. The
								following section of these Terms contains an
								arbitration clause and a class action
								waiver. By agreeing to the Terms, you agree
								to resolve all disputes through binding
								individual arbitration, which means that you
								waive any right to have those disputes
								decided by a judge or jury, and that you
								waive your rights to participate in class
								actions, class arbitrations, or
								representative actions. It is our intention
								to assist in the resolution of any issue you
								may encounter with The Etho's services, or
								any unforeseeable mistakes on our part
								relating to your The Etho account. However,
								if we cannot successfully resolve your
								specific complaints or issues to your
								satisfaction, then the following rules will
								govern any legal dispute involving The
								Etho's services:
							</p>
							<ol>
								<li>
									<p>
										The Etho will attempt to help you or
										your representatives resolve
										disputes based solely on our
										interpretation(s) of The Etho's
										Terms of Use and other policies, and
										at The Etho's sole discretion; The
										Etho will not make judgments
										regarding legal issues or claims,
										and is under no obligation to
										resolve any disputes.
									</p>
								</li>
								<li>
									<p>
										You hereby release The Etho from any
										claims, demands, and damages which
										may arise out of disputes with other
										The Etho users or other parties.
									</p>
								</li>
								<li>
									<p>
										These Terms are governed by the laws
										of the State of Texas, without
										regard to its conflict of laws,
										rules, and the laws of the United
										States of America. These laws will
										apply no matter where in the world
										you live, but if you reside outside
										of the United States, you may be
										entitled to the protection of the
										mandatory consumer protection
										provisions of your local consumer
										protection law.
									</p>
								</li>
								<li>
									<p>
										In any legal dispute involving our
										services, you and The Etho hereby
										agree that any dispute or claim
										arising from or relating to these
										Terms shall be finally settled by
										final and binding arbitration, using
										the English language, and
										administered by the American
										Arbitration Association (the “AAA”)
										under its Commercial Arbitration
										Rules then in effect (those rules
										are deemed to be incorporated by
										reference into this section, and as
										of the date of these Terms you can
										find them here or by calling the AAA
										at 1–800–778–7879). Arbitration will
										be handled by a sole arbitrator in
										accordance with those rules.
										Judgment on the arbitration award
										may be entered in any court that has
										jurisdiction. Any arbitration under
										the Terms will take place on an
										individual basis; class arbitrations
										and class actions are not permitted.
									</p>
								</li>
								<li>
									<p>
										You understand that by agreeing to
										these Terms, you and The Etho are
										each waiving the right to trial by
										jury or to participate in a class
										action or class arbitration.
										Notwithstanding the foregoing, each
										party shall have the right to bring
										an action in a court of proper
										jurisdiction for injunctive or other
										equitable or conservatory relief,
										pending a final decision by the
										arbitrator. You may instead assert
										your claim in “small claims” court,
										but only if your claim qualifies,
										your claim remains in such court,
										and your claim remains on an
										individual, non-representative, and
										non-class basis.
									</p>
								</li>
								<li>
									<p>
										Payment for any and all reasonable
										AAA filing, administrative, and
										arbitrator fees will be in
										accordance with the Consumer
										Arbitration Rules. If the value of
										your claim does not exceed $10,000,
										The Etho will pay for the reasonable
										filing, administrative, and
										arbitrator fees associated with the
										arbitration, unless the arbitrator
										finds that either the substance of
										your claim or the relief sought was
										frivolous or brought for an improper
										purpose.
									</p>
								</li>
								<li>
									<p>
										The Etho is based in Austin, Texas,
										so any legal action against us
										related to The Etho’s services must
										be filed and take place in Austin.
										This means the seat of any
										arbitration shall be Austin, Texas.
										For any actions not subject to
										arbitration, you (where your
										contract is with The Etho, Inc.) and
										The Etho agree to submit to the
										personal jurisdiction of a state
										court located in Travis County,
										Texas or the United States District
										Court for the Western District of
										Texas, or (where The Etho's contract
										is with The Etho Ireland UC) you and
										The Etho agree to submit to the
										personal jurisdiction of the court
										of Ireland.
									</p>
								</li>
								<li>
									<p>
										If you are a government entity or
										designated agent in the United
										States using The Etho’s services in
										an official capacity, and are
										legally unable to agree to the
										clauses in this section, then those
										clauses do not apply to you. In that
										case, the Terms and any actions
										related to these Terms will be
										governed by the laws of the United
										States (without reference to
										conflict of laws) and, in the
										absence of federal law and to the
										extent permitted under federal law,
										the laws of the State of Texas.
									</p>
								</li>
								<li>
									<p>
										If The Etho makes any changes to
										this section (“Disputes with The
										Etho and with Other Users”) after
										the date on which you last accepted
										our Terms, those changes will not
										apply to any claims filed in a legal
										proceeding against The Etho prior to
										the date the changes became
										effective. The Etho will notify you
										of substantive changes to the
										“Disputes with The Etho and with
										Other Users” section at least 30
										days prior to the date the change(s)
										will become effective. If you do not
										agree to the modified terms, you may
										send The Etho a written notification
										(including via email) or close your
										The Etho account within that 30 day
										time frame.
									</p>
								</li>
								<li>
									<p>
										By rejecting a modified version of
										The Etho’s Terms or by permanently
										closing your The Etho account, you
										agree to arbitrate any disputes
										between you and The Etho in
										accordance with the provisions of
										this “Disputes with The Etho and
										with Other Users” section as of the
										date you last accepted the Terms,
										including any changes made prior to
										your rejection of changes. If you
										reopen your closed The Etho account,
										or create a new account, you agree
										to be bound by the current version
										of these Terms.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Warranties and The Etho
							</h4>
							<p>
								By using The Etho, you understand and agree
								that our services are provided “as is” and
								without any kind of warranty, either
								expressed, or implied, and that The Etho is
								expressly disclaiming any warranties of
								title, non-infringement, merchantability,
								and fitness for a particular purpose, as
								well as any warranties implied by any course
								of performance, course of dealing, or usage
								of trade.
							</p>
							<ol>
								<li>
									<p>
										We do not guarantee that: (a) our
										services will be secure or available
										at any particular time or location
										(b) any defects or errors will be
										corrected by The Etho (c) The Etho’s
										services will be free of viruses or
										other harmful materials (d) the
										results of using our services will
										meet customer or seller
										expectations.
									</p>
								</li>
								<li>
									<p>
										You acknowledge and agree by using
										The Etho that you use our services
										solely at your own risk.
									</p>
								</li>
								<li>
									<p>
										By using The Etho, you acknowledge
										and agree that neither The Etho, nor
										The Etho's employees or directors
										shall be liable to you for any loss
										of profits or revenues, or for any
										consequential, incidental, indirect,
										special, or punitive damages arising
										out of or in connection with our
										services or these Terms, to the
										fullest extent permitted by law.
									</p>
								</li>
								<li>
									<p>
										In no event shall The Etho’s
										aggregate liability for any damages
										exceed the larger of one hundred
										($100) US Dollars, or the amount you
										paid The Etho in the past twelve
										months. (Some jurisdictions may not
										allow these limitations on
										incidental or consequential damages,
										so the stated limitations may not
										apply to you).
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>Termination</h4>
							<p>
								You can terminate your account with The Etho
								at any time in The Etho's account settings.
							</p>
							<ol>
								<li>
									<p>
										As stated previously, The Etho
										reserves the right to modify,
										discontinue, or temporarily suspend
										any of our services at any time, for
										any reason, and will not be liable
										to you or anyone for the effect that
										any changes to our services may have
										on you or your business.
									</p>
								</li>
								<li>
									<p>
										We reserve the right to terminate or
										temporarily suspend your The Etho
										account (including any related
										accounts) as well as your access to
										our services for any reason, at any
										time, and without advance notice
										from us. The Etho may refuse our
										services to anyone, at any time, for
										any reason.
									</p>
								</li>
								<li>
									<p>
										The Terms will remain in effect even
										after your access to The Etho’s
										services is terminated, or after
										your use of our services ends.
									</p>
								</li>
								<li>
									<p>
										Any outstanding bills or fees will
										need to be paid to The Etho at the
										time of termination.
									</p>
								</li>
								<li>
									<p>
										The termination of your The Etho
										account will not necessarily remove
										the availability of some of your
										content through The Etho’s services
										generated prior your account’s
										termination.
									</p>
								</li>
								<li>
									<p>
										If you or us terminate your The Etho
										account, you may lose access to any
										information associated with your
										account, including any
										profile-related content.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Scope of The Etho’s Terms of Use
							</h4>
							<p>
								These Terms, including any and all policies
								that make up The Etho’s Terms of Use, shall
								supersede any other agreement between you
								and The Etho in connection with our
								services.
							</p>
							<ol>
								<li>
									<p>
										If any part of our Terms is found to
										be unenforceable, that specific part
										shall be limited to the minimum
										extent necessary so that these Terms
										will otherwise remain in full force
										and effect.
									</p>
								</li>
								<li>
									<p>
										The Etho’s failure to enforce any
										part of these Terms does not
										constitute a waiver of our right to
										later enforce that, or any other
										part, of our Terms of Use; we
										reserve the right to assign any of
										our rights and obligations under
										these Terms at any time.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>
								Changes to The Etho’s Terms of Use
							</h4>
							<p>
								The Etho may update these Terms
								periodically, but if we believe that any
								modifications are material, then we will
								alert The Etho users by doing one (or more)
								of the following: (a) posting any changes
								through the services or (b) sending you an
								email or personal message about any changes,
								that way you can decide whether or not you
								want to continue using our services
							</p>
							<ol>
								<li>
									<p>
										Changes to The Etho’s Terms will be
										effective immediately upon the
										online posting of the changes, and
										all The Etho users are responsible
										for reading and understanding any
										changes.
									</p>
								</li>
								<li>
									<p>
										Your use of The Etho’s services
										following any changes or
										modifications constitutes your
										acceptance of any updated Terms of
										Use that The Etho introduces.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<h4 className=''>Contact Information</h4>
							<p>
								If you have any questions about these Terms,
								please send us an email at:
								<a href='mailto:info@theetho.com'>
									info@theetho.com.
								</a>
							</p>
						</li>
					</ol>
					<p>Last updated August, 2019. © 2019 The Etho, Inc.</p>
				</div>
			</Section>
		</div>
	)
}

export default TermsOfUse
